
import { IState } from '@app/store';
import { getBreadcrumbIds } from '@app/utils/sidebar';
import OfferEvent from '@core/models/offer/OfferEvent';
import { OfferType } from '@core/models/offer/enums';
import { sortBy } from '@core/utils/sort/sortBy';
import { shellLocalConfig } from '@src/config/shell/localConfig';

const ALL_ID = -1000;

interface ISportResultsUIState {}

const createStore = (parentStorePath: string) => ({
    namespaced: true,
    state: {},
    getters: {
        expandedEventId: (state: ISportResultsUIState, getters: any, rootState: IState, rootGetters: any) => {
            const matchId = rootGetters[`${parentStorePath}/expandedEventId`];
            if (!matchId || !rootGetters['data/results/sport/resultsMap'][matchId]) {
                return null;
            }
            return matchId;
        },
        selectedDate(state: any, getters: any, rootState: IState, rootGetters: any) {
            return rootGetters[`${parentStorePath}/selectedDate`];
        },
        breadcrumbIds(state: any, getters: any, rootState: any, rootGetters: any) {
            const bcIds = getBreadcrumbIds(rootGetters['navigation/route'], getters.tree, rootState);
            return bcIds.length > 0 ? bcIds : [ALL_ID];
        },
        filteredMatches(state: any, getters: any) {
            const events = getters.filteredMatchesByDateAndOffer as OfferEvent[];
            const [sportId, categoryId, tournamentId] = getters.breadcrumbIds;
            let filteredEvents = events;
            if (sportId !== ALL_ID) {
                filteredEvents = events.filter((e) =>
                    e.sportId === sportId
                    && (!categoryId || categoryId === e.categoryId)
                    && (!tournamentId || tournamentId === e.tournamentId));
            }

            return sortBy(filteredEvents, shellLocalConfig.sportOfferSort.getEventSortRules());
        },
        filteredMatchesByDateAndOffer(state: any, getters: any, rootState: IState, rootGetters: any) {
            const results = rootGetters['data/results/sport/results'] as OfferEvent[];
            const offerType = getters.offerType as OfferType;
            const filters = [
                (e: OfferEvent) => e.date! >= startDate && e.date! < endDate,
            ];
            if (offerType) {
                filters.push((e: OfferEvent) => e.offerStatus
                    && e.offerStatus[offerType] !== undefined || false);
            }
            const [startDate, endDate] = rootGetters[`${parentStorePath}/timeWindow`];
            return results.filter((e) => filters.every((filter) => filter(e)));
        },
    },
});

export type ResultsUIStore = ReturnType<typeof createStore>;
export default createStore;
